export default "__VITE_ASSET__CIeWsMfb__"